import React from 'react';
import { createStyles } from 'utils/createStyle';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faUmbrellaBeach } from '@fortawesome/pro-regular-svg-icons';
import { colors } from 'styles/settings';

interface BaseBannerProps {
    startDate: string;
    endDate: string;
    editVacationMode: () => void;
    originalToggleValue?: boolean;
}

interface BannerProps extends Omit<BaseBannerProps, 'startDate' | 'endDate'> {
    isVacationModeActive: boolean;
    isVacationModeScheduled: boolean;
    startDate: Date | null;
    endDate: Date | null;
}

const styles = createStyles({
    yellowBannerContainer: [
        'flex items-center gap-1',
        {
            borderRadius: 8,
            background: '#FFFAEB',
            padding: '9px 26px',
            color: '#B54708',
            width: 'fit-content',
        },
    ],
    greenBannerContainer: [
        'flex items-start gap-1',
        {
            borderRadius: 8,
            background: 'rgba(56, 130, 0, 0.08)',
            padding: '9px 26px',
            color: colors.alertGreen,
            width: 'fit-content',
        },
    ],
    editBtn: ['cursor-pointer underline text-brand text-sm font-semibold'],
});

export const ScheduledVacationModeBanner = (props: BaseBannerProps) => {
    return (
        <div className="flex gap-3 items-center mt-3">
            <div className={styles.yellowBannerContainer}>
                <FontAwesomeIcon className="font-semibold mr-1" icon={faClock} color="#B54708" />
                <p className="font-normal">
                    <span className="font-semibold">Vacation Mode Scheduled:</span>{' '}
                    {props.startDate} - {props.endDate}
                </p>
            </div>
            <span className={styles.editBtn} onClick={props.editVacationMode}>
                Edit
            </span>
        </div>
    );
};

export const VacationModeActiveBanner = (props: Omit<BaseBannerProps, 'startDate'>) => {
    return (
        <div className="flex gap-3 items-center mt-3">
            <div className={styles.greenBannerContainer}>
                <FontAwesomeIcon
                    className="font-semibold mt-1 mr-1"
                    icon={faUmbrellaBeach}
                    color={colors.alertGreen}
                />
                <div className="font-normal">
                    <p>
                        This is <span className="font-bold">OFF</span> until {props.endDate} due to
                        Vacation Mode and will{' '}
                        {props.originalToggleValue ? (
                            <>
                                return <span className="font-bold">ON</span>
                            </>
                        ) : (
                            <>
                                remain <span className="font-bold">OFF</span>
                            </>
                        )}{' '}
                        after vacation mode ends.
                    </p>
                    {/* <p>
                        This will return to <span className="font-bold">ON</span> after Vacation
                        Mode ends.
                        </p> */}
                </div>
            </div>
            <span className={styles.editBtn} onClick={props.editVacationMode}>
                Edit
            </span>
        </div>
    );
};

export const VacationModeBanner = (props: BannerProps) => {
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    } as Intl.DateTimeFormatOptions;
    const startDate = props.startDate ? props.startDate.toLocaleDateString('en-US', options) : '';
    const endDate = props.endDate ? props.endDate.toLocaleDateString('en-US', options) : '';
    if (props.isVacationModeActive) {
        return (
            <VacationModeActiveBanner
                endDate={endDate}
                editVacationMode={props.editVacationMode}
                originalToggleValue={props.originalToggleValue}
            />
        );
    } else if (props.isVacationModeScheduled) {
        return (
            <ScheduledVacationModeBanner
                startDate={startDate}
                endDate={endDate}
                editVacationMode={props.editVacationMode}
                originalToggleValue={props.originalToggleValue}
            />
        );
    } else {
        return null;
    }
};
